import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { PrintOptionDto, SelectedPrintOptionDto } from '@/api-sdk';
import { baseStyles, buttonStyles } from '@/styles';
import { t } from '@weavedev/lit-i18next';

/**
 * @element fg-print-option-summary
 */
@customElement('fg-print-option-summary')
export class FgPrintOptionSummary extends LitElement {
  @property({ type: Object })
  option?: PrintOptionDto | SelectedPrintOptionDto;

  render() {
    if (!this.option) {
      return null;
    }

    const { colorCount, position, printTechnique, maxSurface, image } =
      this.option;

    return html`
      ${image
        ? html`
            <img src="${image}" alt="${position}" width="64" height="64" />
          `
        : nothing}
      <div class="specs">
        <strong class="position">${position}</strong>
        <p class="print-technique-colors">
          ${printTechnique
            ? html`
                ${printTechnique}
              `
            : nothing}
          ${printTechnique &&
          (colorCount === null || (colorCount !== undefined && colorCount > 0))
            ? html`
                -
              `
            : nothing}
          ${colorCount && colorCount > 0
            ? html`
                ${t('labels.colors', { count: colorCount })}
              `
            : colorCount === null
              ? html`
                  ${t('labels.fullColor')}
                `
              : nothing}
        </p>
        ${maxSurface
          ? html`
              <p class="max-surface">${maxSurface}</p>
            `
          : nothing}
        <slot name="suffix"></slot>
      </div>
    `;
  }

  static styles = [
    baseStyles,
    buttonStyles,
    css`
      :host {
        display: flex;
        align-items: start;
        gap: 8px;
      }

      img {
        background-color: #fff;
        aspect-ratio: 64 / 64;
        object-fit: contain;
      }

      .specs {
        display: flex;
        flex-direction: column;
      }

      .position {
        display: block;
        font-size: 1rem;
        margin-bottom: 5px;
      }

      .print-technique-colors {
        margin-bottom: 2px;
      }
    `,
  ];
}
